/**
* 获取 清除定时开锁
*/
<template>
	<div>
		<div class="max-w-5xl mx-auto">
			<!-- API 基本信息 -->
			<div class="bg-white rounded-lg shadow-sm p-6 mb-6">
				<div class="flex items-center justify-between mb-4">
					<h2 class="text-2xl font-bold text-gray-800">{{ selectedApi.name }}</h2>
					<span :class="['px-3 py-1 rounded-full text-sm font-medium', 'bg-green-100 text-green-600']">
						{{ selectedApi.status }}
					</span>
				</div>
				<p class="text-gray-600">{{ selectedApi.description }}</p>
			</div>

			<!-- 请求信息 -->
			<div class="bg-white rounded-lg shadow-sm p-6 mb-6">
				<h3 class="text-lg font-bold text-gray-800 mb-4">
					<!-- 请求信息 -->
					{{ $t('language000261') }}
				</h3>

				<div class="mb-4">
					<div class="flex items-center gap-4 mb-2">
						<span :class="['px-2 py-1 rounded text-sm font-medium', methodColors[selectedApi.method]]">
							{{ selectedApi.method }}
						</span>
						<span class="text-gray-600">{{ selectedApi.url }}</span>
					</div>
				</div>

				<div class="mb-6">
					<h4 class="font-medium text-gray-700 mb-3">
						<!-- 请求参数 -->
						{{ $t('language000262') }}
					</h4>
					<div class="overflow-x-auto">
						<table class="w-full">
							<thead class="bg-gray-50">
								<tr>
									<th class="px-4 py-3 text-left text-sm font-medium text-gray-600">
										<!-- 参数名 -->
										{{ $t('language000263') }}
									</th>
									<th class="px-4 py-3 text-left text-sm font-medium text-gray-600">
										<!-- 请求类型 -->
										{{ $t('language000306') }}
									</th>
									<th class="px-4 py-3 text-left text-sm font-medium text-gray-600">
										<!-- 类型 -->
										{{ $t('language000264') }}
									</th>
									<th class="px-4 py-3 text-left text-sm font-medium text-gray-600">
										<!-- 是否必填 -->
										{{ $t('language000265') }}
									</th>
									<th class="px-4 py-3 text-left text-sm font-medium text-gray-600">
										<!-- 说明 -->
										{{ $t('language000266') }}
									</th>
								</tr>
							</thead>
							<tbody class="divide-y divide-gray-200">
								<tr v-for="param in selectedApi.parameters" :key="param.name">
									<td class="px-4 py-3 text-sm text-gray-600">{{ param.name }}</td>
									<td class="px-4 py-3 text-sm text-gray-600"
										:class="param.RequestType === 'header' ? 'text-yellow-600' : 'text-blue-600'">
										{{ param.RequestType }}
									</td>
									<td class="px-4 py-3 text-sm text-gray-600">{{ param.type }}</td>
									<td class="px-4 py-3 text-sm">
										<span :class="[param.required ? 'text-red-600' : 'text-gray-600']">
											{{ param.required ? $t('language000267') : $t('language000268') }}
										</span>
									</td>
									<td class="px-4 py-3 text-sm text-gray-600">{{ param.description }}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>

				<div>
					<h4 class="font-medium text-gray-700 mb-3">
						<!-- 请求示例 -->
						{{ $t('language000269') }}
					</h4>
					<div class="relative">
						<pre
							class="bg-gray-900 text-gray-100 rounded-lg p-4 text-sm overflow-x-auto">{{ selectedApi.requestExample }}
						</pre>
						<button @click="copyCode(selectedApi.requestExample)"
							class="!rounded-button absolute right-2 top-2 bg-gray-800 text-gray-300 px-3 py-1 text-sm hover:bg-gray-700">
							<!-- 复制 -->
							{{ $t('language000195') }}
						</button>
					</div>
				</div>
			</div>

			<!-- 响应信息 -->
			<div class="bg-white rounded-lg shadow-sm p-6">
				<h3 class="text-lg font-bold text-gray-800 mb-4">
					<!-- 响应信息 -->
					{{ $t('language000270') }}
				</h3>

				<div class="mb-6">
					<div class="overflow-x-auto">
						<table class="w-full">
							<thead class="bg-gray-50">
								<tr>
									<th class="px-4 py-3 text-left text-sm font-medium text-gray-600">
										<!-- 参数名 -->
										{{ $t('language000263') }}
									</th>
									<th class="px-4 py-3 text-left text-sm font-medium text-gray-600">
										<!-- 类型 -->
										{{ $t('language000264') }}
									</th>
									<th class="px-4 py-3 text-left text-sm font-medium text-gray-600">
										<!-- 说明 -->
										{{ $t('language000266') }}
									</th>
								</tr>
							</thead>
							<tbody class="divide-y divide-gray-200">
								<tr>
									<td class="px-4 py-3 text-sm text-gray-600">code</td>
									<td class="px-4 py-3 text-sm text-gray-600">integer(int64)</td>
									<td class="px-4 py-3 text-sm text-gray-600">
										<!-- 状态码 -->
										{{ $t('language000319') }}
									</td>
								</tr>
								<tr @click="isDataVisible = !isDataVisible" class="cursor-pointer">
									<td class="px-4 py-3 text-sm text-gray-600" colspan="3">
										<strong>data</strong>
										<span v-if="isDataVisible">▼</span>
										<span v-else>▲</span>
									</td>
								</tr>
								<template v-if="isDataVisible">
									<tr v-for="param in selectedApi.data" :key="param.name" class="bg-gray-50">
										<td class="px-4 py-3 text-sm text-gray-600">{{ param.name }}</td>
										<td class="px-4 py-3 text-sm text-gray-600">{{ param.type }}</td>
										<td class="px-4 py-3 text-sm text-gray-600">{{ param.description }}</td>
									</tr>
								</template>
								<tr>
									<td class="px-4 py-3 text-sm text-gray-600">message</td>
									<td class="px-4 py-3 text-sm text-gray-600">string</td>
									<td class="px-4 py-3 text-sm text-gray-600">
										<!-- 返回信息 -->
										{{ $t('language000396') }}
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>

				<div class="mb-6">
					<h4 class="font-medium text-gray-700 mb-3">
						<!-- 响应示例 -->
						{{ $t('language000271') }}
					</h4>
					<div class="relative">
						<pre
							class="bg-gray-900 text-gray-100 rounded-lg p-4 text-sm overflow-x-auto">{{ selectedApi.responseExample }}
						</pre>
						<button @click="copyCode(selectedApi.responseExample)"
							class="!rounded-button absolute right-2 top-2 bg-gray-800 text-gray-300 px-3 py-1 text-sm hover:bg-gray-700">
							<!-- 复制 -->
							{{ $t('language000195') }}
						</button>
					</div>
				</div>

				<div>
					<h4 class="font-medium text-gray-700 mb-3">
						<!-- 错误码说明 -->
						{{ $t('language000272') }}
					</h4>
					<div class="overflow-x-auto">
						<table class="w-full">
							<thead class="bg-gray-50">
								<tr>
									<th class="px-4 py-3 text-left text-sm font-medium text-gray-600">
										<!-- 错误码 -->
										{{ $t('language000273') }}
									</th>
									<th class="px-4 py-3 text-left text-sm font-medium text-gray-600">
										<!-- 说明 -->
										{{ $t('language000274') }}
									</th>
									<th class="px-4 py-3 text-left text-sm font-medium text-gray-600">
										<!-- 解决方案 -->
										{{ $t('language000275') }}
									</th>
								</tr>
							</thead>
							<tbody class="divide-y divide-gray-200">
								<tr v-for="error in localizedErrorCodes" :key="error.code">
									<td class="px-4 py-3 text-sm text-red-600">{{ error.code }}</td>
									<td class="px-4 py-3 text-sm text-gray-600">{{ error.message }}</td>
									<td class="px-4 py-3 text-sm text-gray-600">{{ error.solution }}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>


			</div>
		</div>
	</div>
</template>

<script>
	import {
		errorCodes
	} from '../../../equipment/current/ErrorCodes.js';

	export default {
		mounted() {},
		data() {
			return {
				isDataVisible: false,
				selectedApi: {
					name: this.$t('language000374'), //清除定时开锁
					status: this.$t('language000287'), //已发布
					description: '',
					method: 'POST',
					url: this.$p_url_Developers + '/device/toyMetalShakeLockBluetooth/getMetalShakeClearTimingLockCmd',

					parameters: [{
						name: 'Authorization',
						RequestType: "header",
						type: 'string',
						required: true,
						description: 'Api Token'
					}, {
						name: 'Environment',
						RequestType: "header",
						type: 'string',
						required: true,
						description: this.$t('language000346') //所属环境 TEST测试  PRODUCT正式
					}, {
						name: ' bluetoothAddress',
						RequestType: "body",
						type: 'string',
						required: true,
						description: this.$t('language000288'), //蓝牙地址
					}, {
						name: 'serialNumber',
						RequestType: "body",
						type: 'string',
						required: true,
						description: this.$t('language000295'), //设备编码
					}, {
						name: 'typeId',
						RequestType: "body",
						type: 'integer(int32)',
						required: true,
						description: this.$t('language000289') + "：" + 15, //设备类型
					}],

					requestExample: `{
" bluetoothAddress": "00:11:22:33:FF:EE",
"serialNumber": "QIUIrjJb07523964",
" typeId":"15"
}`,
					response: [{
						name: 'code',
						type: 'integer(int64)',
						description: this.$t('language000319'), //状态码
					}, {
						name: 'data',
						type: 'boolean',
						description: '',
					}, {
						name: 'message',
						type: 'string',
						description: ''
					}],

					data: [{
						name: '',
						type: '',
						description: ''
					}],
					responseExample: `{
	"code": 0,
	"data": "",
	"message": ""
}`,
					errorCodes: errorCodes // 引入错误码
				},
				methodColors: {
					GET: 'bg-green-100 text-green-600',
					POST: 'bg-blue-100 text-blue-600',
					PUT: 'bg-yellow-100 text-yellow-600',
					DELETE: 'bg-red-100 text-red-600'
				}
			};
		},
		methods: {
			copyCode(key) {
				const input = document.createElement('input'); // 创建一个临时的输入框
				input.value = key; // 将要复制的内容赋值给输入框
				document.body.appendChild(input); // 将输入框添加到文档中
				input.select(); // 选中输入框中的文本
				input.setSelectionRange(0, 99999); // 对于移动设备
				document.execCommand('copy'); // 执行复制命令
				document.body.removeChild(input); // 移除临时输入框
				this.$message({
					message: this.$t('language000064'),
					type: 'success'
				});
			}
		},
		computed: {
			localizedErrorCodes() {
				return this.selectedApi.errorCodes.map(error => ({
					code: error.code,
					message: error.message[this.$i18n.locale === 'zh-CN' ? 'zh' : this.$i18n.locale] || error
						.message['en'], // 如果没有识别出来，默认为英语
					solution: error.solution[this.$i18n.locale === 'zh-CN' ? 'zh' : this.$i18n.locale] || error
						.solution['en'] // 同样处理 solution
				}));
			}
		},
		//...
	};
</script>

<style scoped>
	/* 这里可以添加样式 */
</style>